export default "__VITE_ASSET__guM6sJL5__"